module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "orders",
    staticClass: "orders"
  }, [_c('div', {
    staticClass: "orders-content"
  }, [_c('div', {
    staticClass: "rating-wrapper"
  }, [_c('ul', _vm._l((_vm.orders), function(item) {
    return _c('li', {
      staticClass: "rating-item",
      on: {
        "click": function($event) {
          _vm.selectFood(item, $event)
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.$t("total")) + "：" + _vm._s(item.Total) + " €")]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(item.Status))])]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(item.Sheet))])]), _vm._v(" "), _c('div', {
      staticClass: "star-wrapper"
    }, [_c('span', {
      staticClass: "delivery"
    }, [_vm._v(_vm._s(_vm.$t("address")) + ": " + _vm._s(item.Address))])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("changeDate")(item.OrderDate)) + "\n                ")])])])
  }))])]), _vm._v(" "), _c('orderdetails', {
    ref: "orderdetails",
    attrs: {
      "orderdetailsobj": _vm.orderdetailsobj
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b2e96f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/orders.vue
// module id = 476
// module chunks = 1